<template>
  <el-button type="primary" v-if="needDJ && commitAction" class="bear-registration-button" @click="init">选择入场登记</el-button>
  <el-dialog
    title="选择入场登记"
    top="5vh"
    width="1230px"
    custom-class="dlg-registration"
    :close-on-click-modal="false"
    v-model="dlgVisible"
  >
    <div :loading="loading">
      <el-form :model="param" label-width="80px" inline>
        <el-form-item label="标段名称">
          <el-input v-model="param.bidSectionName"></el-input>
        </el-form-item>
        <el-form-item label="项目编号">
          <el-input v-model="param.projectCode"></el-input>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker
            v-model="dateRange.Time"
            type="daterange"
            format="YYYY-MM-DD"
            range-separator="到"
            @change="rangeHandle"
          ></el-date-picker>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="doSearch">搜 索</el-button></el-form-item>
      </el-form>
      <el-table :data="regSections" border stripe>
        <el-table-column label="序号" type="index" align="center" width="60px"></el-table-column>
        <el-table-column label="标段名称" prop="bid_section_name"></el-table-column>
        <el-table-column label="创建时间" prop="data_create_time" align="center" width="160px"></el-table-column>
        <el-table-column label="操作" align="center" width="120px">
          <template #default="scope">
            <el-button type="primary" @click="selectIndex(scope.$index)">选 择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bear-registration-footer">
        <el-pagination 
          class="bear-registration-pagination"
          :total="total"
          :page-size="param.pagesize"
          :current-page="param.pageindex"
          @current-change="currentChange"
          layout="prev, pager, next, jumper"
          background
        ></el-pagination>      
      </div>
    </div>
  </el-dialog>
</template>
<script>
import utils from '../../common/js/utils'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'BearRegistration',
  data() {
    return {
      loading: false,
      dlgVisible: false,
      total: 0,
      dateRange: {
        Time: null
      },
      regSections: [],
      param: {
        ds: 'getSectionByProjectCode',
        projectCode: '',
        bidSectionName: '',
        beginTime: '',
        endTime: '',
        pagesize: 10,
        pageindex: 1
      }
    }
  },
  computed: {
    ...mapState(['commitAction', 'needDJ']),
  },
  methods: {
    init() {
      this.dlgVisible = true
      this.total = 0
      this.regSections = []
      this.doSearch()
    },
    doSearch() {
      this.param.pageindex = 1
      this.initList()
    },
    initList() {
      this.loading = true
      this.requestRegSections(this.param).then(({list, total}) => {
        this.loading = false
        this.regSections = list
        this.total = total
      })
    },
    currentChange(page) {
      this.param.pageindex = page
      this.initList()
    },
    rangeHandle(value) {
      let [beginTime, endTime] = value || [null, null]
      this.param.beginTime = beginTime ? utils.DateFormat('yyyy-MM-dd 00:00:00', beginTime) : ''
      this.param.endTime = endTime ? utils.DateFormat('yyyy-MM-dd 23:59:59', endTime) : ''
    },
    selectIndex(index) {
      let {tender_project_code, tender_id} = this.regSections[index]
      this.$confirm('确定选择这条入场登记', '操作确认', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(e => {
        this.loading = true
        this.requestRegSectionDetail({
          tenderProjectCode: tender_project_code,
          tenderId: tender_id
        }).then(res => {
          this.loading = false
          this.dlgVisible = false
          this.transRegInfoToTheForm(res)
        })        
      }).catch(e => null)
    },
    ...mapActions(['requestRegSections', 'requestRegSectionDetail', 'transRegInfoToTheForm'])
  }
}
</script>
<style lang="scss" scoped>
.bear-registration-button {
  margin: 5px;
}
.bear-registration-footer {
  margin: -1px 0;
  padding: 5px;
  border: 1px solid #ebeef5;
}
.bear-registration-pagination {
  justify-content: right;
}
</style>
<style lang="scss">
.dlg-registration {
  .el-dialog__headerbtn {
    .el-dialog__close {
      font-size: 28px;
    }    
  }
}
</style>